import { createLocalJWKSet, jwtVerify, type JWTPayload } from 'jose'
import { logger } from '@mc/pino-logger'
import { getJwks } from './jwksCache'

export const verifyAccessToken = async (
  token: string,
): Promise<JWTPayload | null> => {
  if (!token) return null

  try {
    const jwks = await getJwks()
    const keyset = createLocalJWKSet(
      jwks as Parameters<typeof createLocalJWKSet>[0],
    )
    const { payload } = await jwtVerify(token, keyset, {
      algorithms: ['RS256'],
    })
    return payload
  } catch (error) {
    logger.warn({ msg: 'JWT verification failed', error })
    return null
  }
}
